var exports = {
  "g": "xe533113f--a773af--room-type-filter",
  "B": "xe533113f--a773af--skeleton-filter",
};

module.exports = exports;
